import React from 'react';
import BackNavbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { MotionAnimate } from 'react-motion-animate';
import ReactPlayer from 'react-player';
import { getMediaProvider, isGoogleDriveThumbnailUrl, normalizeMediaUrl } from '../../../Utils/mediaUrls';

const WhatNew = () => {
    const { id } = useParams();
    const { newContent } = useSelector(state => state.whatNewReducer);

    const content = newContent.find(item => item._id === id);

    if (!content) {
        return <p>Content not found</p>;
    }

    // Function to split the fullDescription into three parts
    const splitDescription = (description) => {
        const totalLength = description.length;
        const periods = [];
        const chunks = [];

        // Identify the positions of all periods
        for (let i = 0; i < description.length; i++) {
            if (description[i] === '.') {
                periods.push(i);
            }
        }

        // Calculate the approximate length of each chunk
        const chunkLength = Math.ceil(totalLength / 3);
        let lastSplit = 0;

        for (let i = 1; i <= 2; i++) {
            const splitIndex = periods.find(p => p > lastSplit + chunkLength);
            if (splitIndex) {
                chunks.push(description.slice(lastSplit, splitIndex + 1).trim());
                lastSplit = splitIndex + 1;
            }
        }

        chunks.push(description.slice(lastSplit).trim());
        return chunks;
    };

    const descriptionChunks = splitDescription(content?.fullDescription);

    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    const convertEscapedNewlinesToBr = (text) => {
        return text
            ?.replace(/\\n/g, '<br/>')
            .replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
    };

    const getContentUrl = (item) => (typeof item === 'string' ? item : item?.url || item?.src || item?.viewUrl);

    const getContentType = (item) => {
        if (!item || typeof item === 'string') {
            return '';
        }

        return String(item.mediaType || item.type || item.contentType || item.mimeType || '').toLowerCase();
    };

    // Render content dynamically: Image or Video
    const renderContent = (item, className) => {
        const url = getContentUrl(item);
        const mediaType = getContentType(item);
        const isDriveMedia = getMediaProvider(url) === 'google-drive';
        const isVideo = mediaType.includes('video') || url?.endsWith('.mp4');
        const isImage = mediaType.includes('image') || isGoogleDriveThumbnailUrl(url) || !isVideo;

        if (!url) {
            return null;
        }

        if (isDriveMedia && isVideo) {
            return (
                <center>
                    <iframe
                        src={normalizeMediaUrl(url, 'preview')}
                        title="Feature preview"
                        className={className}
                        width="100%"
                        height="480"
                        frameBorder="0"
                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                </center>
            );
        }

        if (!isDriveMedia && isVideo) {
            return (
                <center>
                    <ReactPlayer 
                        url={url} 
                        controls
                        width="100%"
                        height="auto"
                        className={className}
                    />
                </center>
            );
        } else if (isImage) {
            return (
                <center>
                    <img src={normalizeMediaUrl(url, 'image')} className={className} alt="Feature" />
                </center>
            );
        }

        return null;
    };

    return (
        <>
            <BackNavbar PAGE_NAME="Home" />
            <section className='what-new-background-page'>
                <br />
                <div className='container'>
                    <div className='div-what'>
                        <div className='content'>
                            <p className='card-matter-date-new'>{formatDate(content.releaseDate)}</p>
                            <h2 className='what-det-title'>{content.title}</h2>

                            {renderContent(content.content[0], 'feature-main-img')}
                            
                            <p className='what-det-para' dangerouslySetInnerHTML={{ __html: convertEscapedNewlinesToBr(descriptionChunks[0]) }} />

                            {renderContent(content.content[1], 'feature-img-1')}
                            <div className='what-det-para-1' dangerouslySetInnerHTML={{ __html: convertEscapedNewlinesToBr(descriptionChunks[1]) }} />

                            {renderContent(content.content[2], 'feature-img-1')}
                            <div className='what-det-para-1' dangerouslySetInnerHTML={{ __html: convertEscapedNewlinesToBr(descriptionChunks[2]) }} />
                        </div>
                    </div>
                </div>
                <br />
            </section>
        </>
    );
}

export default WhatNew;
